import { useState, useEffect } from "react";
import { fetchData } from "./dataCache";

/**
 * The metric / filter catalogue for one endpoint, grouped by category.
 *
 * `/api/metrics` and `/api/config/filters` are configuration, not per-query data, and the catalogue is
 * re-mounted every time the user opens it. Going through the request cache means one request per
 * session rather than one per open.
 */
export const useFetchFeatures = (endpoint) => {
  const [features, setFeatures] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const body = await fetchData(endpoint);
        const data = body[endpoint.includes("metrics") ? "metrics" : "filters"];
        // Filter out features with "topline" category
        const filteredData = data.filter(
          (feature) => feature.category !== "topline"
        );
        setFeatures(filteredData);
        setIsLoading(false);
      } catch (error) {
        console.error(`Error fetching ${endpoint}:`, error);
        setIsLoading(false);
      }
    };

    fetchFeatures();
  }, [endpoint]);

  const categorizedFeatures = features.reduce((acc, feature) => {
    if (!acc[feature.category]) {
      acc[feature.category] = [];
    }
    acc[feature.category].push(feature);
    return acc;
  }, {});

  return { features, categorizedFeatures, isLoading };
};
